module.exports = __webpack_public_path__ + "img/azores-islands.1589336b.svg";